import is from '../_helpers/is.js';
import assign from '../_helpers/assign.js';
// returns a function which is called when property value is changed
export default function createObjectHandler(_ref) {
  var node = _ref.node,
    propDef = _ref.propDef,
    binder = _ref.binder,
    bindingOptions = _ref.bindingOptions;
  return function objectHandler(eventOptions) {
    var _field$ownerDocument;
    if (eventOptions === void 0) {
      eventOptions = {};
    }
    var value = propDef.value;
    var _eventOptions = eventOptions,
      changedNode = _eventOptions.changedNode,
      evtBinder = _eventOptions.binder,
      onChangeValue = _eventOptions.onChangeValue;
    var fromThisNode = changedNode === node && evtBinder === binder;
    // a change that came from this node through this binder isn't written back while the node shows that value,
    // also as typed text of the same number ('' for 0, '1.50' for 1.5); a mediator that changed it (a clamp, 'ABC')
    // is written back
    if (fromThisNode && (is(value, onChangeValue) || typeof value === 'number' && is(Number(onChangeValue), value))) {
      return;
    }
    // the field being typed in keeps its caret through the mediator's rewrite; null for a field with no selection
    // (number, email and the like)
    var field = node;
    var _ref2 = fromThisNode && ((_field$ownerDocument = field.ownerDocument) == null ? void 0 : _field$ownerDocument.activeElement) === field ? field : noSelection,
      selectionStart = _ref2.selectionStart,
      selectionEnd = _ref2.selectionEnd;
    // the handler is made only for a binder with setValue
    binder.setValue.call(node, value, assign({}, bindingOptions));
    if (typeof selectionStart === 'number' && typeof selectionEnd === 'number') {
      var length = field.value.length;
      field.setSelectionRange(Math.min(selectionStart, length), Math.min(selectionEnd, length));
    }
  };
}
var noSelection = {
  selectionStart: null,
  selectionEnd: null
};